import AuditLogsIndex from "./Index";

const auditLogsRoutes = [
    {
        path: "/core/audit-logs",
        element: <AuditLogsIndex />,
    },
];

export default auditLogsRoutes;